import AdminRouters from './AdminRouters'
import AttributeRouters from './AttributeRouters'
import AuthRouters from './AuthRouters'
import CategoryRouters from './CategoryRouters'
import CommentRouters from './CommentRouters'
import CouponRouters from './CouponRouters'
import CustomerRouters from './CustomerRouters'
import CustomRouters from './CustomRouters'
import EmailMarketingRouters from './EmailMarketingRouters'
import FulfillmentRouters from './FulfillmentRouters'
import InventoryRouters from './InventoryRouters'
import MediaRouters from './MediaRouters'
import OrderRouters from './OrderRouters'
import ProductRouters from './ProductRouters'
import TagRouters from './TagRouters'
import ReviewRouters from './ReviewRouters'
import AnalyticRouters from './AnalyticRouters'
import PointRewardRouters from './PointRewardRouters'
import PromotionRouters from './PromotionRouters'
import PerformanceRouters from './PerformanceRouters'

const Routers = [
  ...AuthRouters,
  ...CustomRouters,
  ...ProductRouters,
  ...CustomerRouters,
  ...PointRewardRouters,
  ...MediaRouters,
  ...OrderRouters,
  ...CouponRouters,
  ...TagRouters,
  ...ReviewRouters,
  ...CategoryRouters,
  ...AttributeRouters,
  ...FulfillmentRouters,
  ...CommentRouters,
  ...InventoryRouters,
  ...AnalyticRouters,
  ...PromotionRouters,
  ...PerformanceRouters,
  ...EmailMarketingRouters,
  ...AdminRouters,
]

export default Routers
